// 1 hour
export const VM_TIMEOUT_MS = Math.floor(60 * 60 * 1000);

export const AI_HUMAN_HELP_SIGNAL = 'human-help';
